import "./brand-logo.css";

/**
 * The VozQI lockup. There are two drawings, because the navy «oz» vanishes on
 * the dark ground: `pnpm icons` (apps/vozqi/mobile/scripts/make-icons.mjs)
 * renders a dark one with «oz» in white. Both are in the page and CSS shows
 * one (`brand-logo.css`), so it follows the theme toggle and the
 * system's preference alike, with no render and no flash.
 */
export function BrandLogo({ height }: { height: number }) {
  // 720x208: the lockup cropped to its ink.
  const width = Math.round((height * 720) / 208);
  return (
    <span className="brand-logo" role="img" aria-label="VozQI">
      <img className="brand-logo-light" src="/brand/vozqi-logo.png" alt="" width={width} height={height} />
      <img className="brand-logo-dark" src="/brand/vozqi-logo-dark.png" alt="" width={width} height={height} />
    </span>
  );
}
